"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config = {
    Auth: {
        userPoolId: 'us-west-2_U1IO7b9az',
        userPoolWebClientId: '22mhnp80sgg0mb3cvr9vi2b42c',
        region: 'us-west-2'
    },
    Analytics: {
        disabled: true
    },
    TYPE: 'API_KEY',
    ENDPOINT: 'endpoint',
};
exports.default = config;